import { render, staticRenderFns } from "./FeedbackFormStatusCard.vue?vue&type=template&id=d64f31aa&"
import script from "./FeedbackFormStatusCard.vue?vue&type=script&lang=js&"
export * from "./FeedbackFormStatusCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports